import { render, staticRenderFns } from "./AssistenteIntegracao.vue?vue&type=template&id=2796b71e&scoped=true"
import script from "./AssistenteIntegracao.vue?vue&type=script&lang=js"
export * from "./AssistenteIntegracao.vue?vue&type=script&lang=js"
import style0 from "./AssistenteIntegracao.vue?vue&type=style&index=0&id=2796b71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796b71e",
  null
  
)

export default component.exports